import { render, staticRenderFns } from "./MemberAffiliate.vue?vue&type=template&id=15b42e29"
import script from "./MemberAffiliate.vue?vue&type=script&lang=js"
export * from "./MemberAffiliate.vue?vue&type=script&lang=js"
import style0 from "./MemberAffiliate.vue?vue&type=style&index=0&id=15b42e29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports